// extracted by mini-css-extract-plugin
export var body = "_m1-0";
export var sectionHeader = "_m1-4";
export var shortcutColumns = "_m1-2";
export var shortcutList = "_m1-1";
export var shortcutSection = "_m1-3";